import { AbstractControl } from '@angular/forms';
var Filter  = require("bad-words");

var filter = new Filter()
export function CheckBadWord(control: AbstractControl) {

	let word = control.value
	if (filter.isProfane(word)) {
		return {
			'invalidWord': true
		}
	}
	return null
}


// WEBPACK FOOTER //
// ./src/app/services/validators/bad-word.validator.ts